// extracted by mini-css-extract-plugin
export default {"modalContainer":"style_modalContainer__cijG+","content":"style_content__74RDU","btn":"style_btn__A1fFk","active":"style_active__30Idh"};